import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const FscdPartnership = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              FSCD Partnership
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Link and Learn Academy is a direct partner of Alberta’s FSCD
                program enabling us to offer all FSCD funded services for your
                child through our certified therapists, aides and respite
                workers. Additionally, the partnership with FSCD allows for
                direct billing to FSCD for all services. Link and Learn
                Academy’s holistic management of FSCD clients enables us to
                guide families every step along the way from the initial
                application to the Alberta government, to contract renewal
                meetings straight through to the late teen years in which
                clients transition to adult oriented programs.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/fscd.jpeg'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FscdPartnership;
